import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ContactUsMessage } from 'src/types/shared/ContactUsMessages';

export const fetchSingleContactUsMessageRequest = createAction(
    'fetchSingleContactUsMessageRequest',
);
export const fetchSingleContactUsMessageSuccess = createAction<ContactUsMessage>(
    'fetchSingleContactUsMessageSuccess',
);
export const fetchSingleContactUsMessageFailure = createAction(
    'fetchSingleContactUsMessageFailure',
);

export const fetchSingleContactUsMessage = (id: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchSingleContactUsMessageRequest());
    try {
        const { data }: Response = await api.get(`admin/contactusmessages/${id}`);
        dispatch(fetchSingleContactUsMessageSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchSingleContactUsMessageFailure, e);
    }
};

interface Response {
    data: ContactUsMessage;
}
